<template>
  <div>
    <a
      tooltip="Comments"
      @click.stop="drawer = !drawer"
    >
      <i
        class="fa fa-commenting cyan--text "
        style="font-size: 22px"
      />
    </a>

    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
      width="450"
      right
      class="comment-aside"
    >
      <div class="comment-container">
        <div
          class="py-2 px-4 black--text comment-title"
          style="font-size: 2rem; border-bottom: 1px solid #ccc"
        >
          {{ title }}
        </div>

        <v-card-text
          id="comment-panel"
          style="height: 82vh; overflow-y: scroll"
        >
          <div class="row">
            <div
              v-for="comment in comments"
              :key="comment.id"
              class="col-12 pb-3 pl-1 pr-3"
            >
              <div class="d-flex">
                <div
                  style="width: 35px"
                  class="pr-1"
                >
                  <v-avatar
                    :color="avatarColor(comment)"
                    size="30"
                  >
                    <span
                      class="white--text text-bold"
                      style="font-size: 1.5rem"
                    >
                      {{ comment.user.full_name[0] }}
                    </span>
                  </v-avatar>
                </div>

                <div style="width: 100%">
                  <div
                    class="grey lighten-3 pa-2 px-3"
                    style="border-radius: 6px; font-size: 1.5rem"
                  >
                    <div class="text-bold mb-1">
                      {{ comment.user.full_name }}
                    </div>
                    <div class="black--text">
                      {{ comment.description }}
                    </div>
                  </div>

                  <div class="text-caption dir-ltr d-inline-block pl-2 text--secondary">
                    {{ comment.created_at | moment('YYYY-MM-DD hh:mm a') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>

        <div class="pa-3 comment-actions">
          <div
            class="d-flex"
            style="position: relative"
          >
            <div style="width: 100%">
              <textarea
                id="comment-input-field"
                v-model="form.description"
                class="form-control grey lighten-3"
                style="font-size: 1.5rem; border-radius: 4px"
                rows="3"
                placeholder="Your comment..."
              />
            </div>
            <div style="width: 45px">
              <button
                type="button"
                class="blue white--text pt-1 pl-1"
                style="border-radius: 50%; width: 35px; height: 35px;position: absolute; bottom: 0; right: 0px;"
                @click="storeComment()"
              >
                <i class="material-icons">send</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    modelId: { type: Number, required: true },
    modelName: { type: String, required: true },
    title: { type: String, required: true }
  },

  data() {
    return {
      drawer: false,
      form: {},
      comments: [],
      colors: [
        'blue lighten-2',
        'green lighten-2',
        'pink lighten-2',
        'yellow darken-1',
        'orange lighten-2',
        'brown lighten-2',
        'cyan lighten-2',
        'teal lighten-2',
        'purple lighten-2'
      ],
      userColors: [],
      selectedColors: []
    }
  },

  watch: {
    drawer(val) {
      if (val) {
        this.getComments()
      }
    }
  },

  methods: {
    avatarColor(comment) {
      let foundUserColor = this.userColors.find((c) => c.user_id === comment.user_id_fk)

      if (foundUserColor) {
        return foundUserColor.color
      }

      let filteredColors = this.colors.filter((color) => !this.selectedColors.includes(color))
      let newColor = filteredColors[Math.floor(Math.random() * filteredColors.length)]

      this.selectedColors.push(newColor)
      this.userColors.push({ user_id: comment.user_id_fk, color: newColor })

      return newColor
    },

    getComments() {
      let payload = {
        model_id: this.modelId,
        model_name: this.modelName
      }

      let token = localStorage.getItem('access_token')
      axios.get('api/comment', { params: payload, headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.comments = res.data
      })
    },

    storeComment() {
      this.form.model_id = this.modelId
      this.form.model_name = this.modelName

      let token = localStorage.getItem('access_token')
      axios.post('api/comment', this.form, { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.form = {}
        document.querySelector('#comment-input-field').focus()
        this.comments.push(res.data)
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      })
    },

    scrollToBottom() {
      var objDiv = document.getElementById('comment-panel')
      objDiv.scroll({ top: objDiv.scrollHeight, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.comment-aside {
  padding: 0px !important;
}

.comment-container {
  height: 100vh;
  position: relative;
}

.comment-title {
  position: sticky;
  top: 0;
}

.comment-actions {
  position: absolute;
  bottom: 0;
  width: 100%;
}

a {
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 0%;
  bottom: 160%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/Comment.vue